import T from '../../i18n/Text';
import { Link } from "react-router-dom";
import { Game } from '../../types';
import GameOptionsIconList from '../GameOptionsIconList';

interface Props {
    game: Game;
}

const GameItem = ({ game }: Props) => {

    return (
        <div className="w-full md:aspect-{0.4} lg:aspect-{0.32} xl:aspect-{0.35} md:flex bg-white rounded-[6px] ">
            <div className="w-full md:w-[40%] lg:w-[32%] xl:w-[35%] aspect-square rounded-tl-[6px] rounded-tr-[6px] md:rounded-bl-[6px] md:rounded-tr-0">
                <img className='w-full h-full' src={`/images/games/${game.name}.png`} alt={game.name} />
            </div>
            <div className="flex flex-col justify-between items-center lg:items-start w-full md:w-[60%] lg:w-[68%] xl:w-[65%] pt-[23px] pr-[10px] pb-[11px] pl-[11px] md:pt-[12px] md:pr-[18px] md:pb-[18px] md:pl-[20px] lg:pt-[55px] xl:pr-[34px] xl:pb-[46px] xl:pl-[46px] ">
                <div>
                    <div className="lg:flex justify-between items-baseline">
                        <h3 className="text-[28px] lg:text-[36px] leading-[34px] lg:leading-[44px] font-medium mb-[12px] xl:mb-[41px] text-center md:text-left">
                            <T path={`games.${game.name}.name`} />
                        </h3>
                        <GameOptionsIconList game={game} />
                    </div>
                    <p className="text-[16px] leading-[22px] lg:text-[20px] lg:leading-[28px] font-medium mb-[10px] lg:mb-[21px] xl:mb-[37px] line-clamp-7 md:line-clamp-3 lg:line-clamp-4">
                        <T path={`games.${game.name}.description`} />
                    </p>
                </div>
                <Link to={`/games/${game.name}`} className="flex justify-center items-center text-white bg-[#252429] border-none hover:bg-[#198754] w-full md:w-[210px] h-[54px] rounded-[3px] text-[20px] leading-6 font-semibold disabled:bg-[#B6B6B6] disabled:border-none transition-colors ease-in-out duration-200">
                    <T path="games.buttons.play" />
                </Link>
            </div>
        </div>
    )
};

export default GameItem;
